<template>
  <DataTableAsync :data="tableData" v-model="tableState" :length="(data || []).length" :isLoading="isLoading" noSearch>
    <template #head>
      <tr>
        <Th prop="orderId" sort>PO #</Th>
        <Th prop="productName" sort>Product Name</Th>
        <Th prop="customerName" sort>Customer Name</Th>
        <Th prop="productStatus" sort>Order Status</Th>
        <Th prop="fedexId" sort>Order Date</Th>
      </tr>
    </template>
    <template #body="{ item }">
      <tr>
        <td>
          <span class="clickable" @click.prevent="viewOrderDetails(item.orderId, item.orderKey)">{{ item.orderId }}</span>
        </td>
        <td>{{ item.productName }}</td>
        <td>{{ item.customerName }}</td>
        <td>{{ item.orderStatus }}</td>
        <td>{{ dateFormat(item.orderDate) }}</td>
      </tr>
    </template>
  </DataTableAsync>
</template>

<script>
import DataTableAsync from '../common/dataTable/DataTableAsync.vue';
import Th from '../common/dataTable/Th.vue';
export default {
  components: { DataTableAsync, Th },
  props: ['data', 'isLoading'],
  data() {
    return {
      tableState: { page: 1, perPage: 25, searchText: null, },
    };
  },
  computed: {
    tableData() {
      var response = this.data || [];
      if (this.tableState.sortByProp) {
        var sortFnc = new Function('value', `return value.${this.tableState.sortByProp}`);
        response = response.sortBy(sortFnc);
        if (this.tableState.sortDirection === 'desc')
          response = response.reverse();
      }

      return response
        .skip(this.tableState.perPage * (this.tableState.page - 1))
        .take(this.tableState.perPage);
    },
  },
  methods: {
    viewOrderDetails(orderId, orderKey) {
      this.$emit('view-order-details', orderId, orderKey);
    },
  },
};
</script>
